
import request from '@/utils/request'

// 是否有注销资格
export function check_qualify(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_destroy/check_qualify',
    method: 'post',
    data
  })
}
// 提交注销申请
export function apply_verify(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_destroy/apply_verify',
    method: 'post',
    data
  })
}
// 填充注销原因/游戏建议
export function fill(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_destroy/fill',
    method: 'post',
    data
  })
}
// 判断是否有取消注销资格
export function check_cancel_qualify(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_destroy/check_cancel_qualify',
    method: 'post',
    data
  })
}
// 提交取消注销申请
export function cancel_apply_verify(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_destroy/cancel_apply_verify',
    method: 'post',
    data
  })
}

// 单手游

// 是否有注销资格
export function check_game_qualify(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_game_destroy/check_qualify',
    method: 'post',
    data
  })
}
// 提交注销申请
export function single_apply_verify(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_game_destroy/apply_verify',
    method: 'post',
    data
  })
}
// 填充注销原因/游戏建议
export function single_fill(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_game_destroy/fill',

    method: 'post',
    data
  })
}
// 判断是否有取消注销资格
export function single_cancel_apply_qualify_verify(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_game_destroy/check_cancel_qualify',

    method: 'post',
    data
  })
}
// 提交取消注销申请
export function single_cancel_apply_verify(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_game_destroy/cancel_apply_verify',

    method: 'post',
    data
  })
}

// 渠道注销申请
export function channel_destroy(data) {
  return request({
    url: process.env.VUE_APP_MEMBERWEB + '/user_destroy/channel_destroy?channel=' + data,
    method: 'get'
  })
}
